export default {
  // 공통
  view: 'testbank__list',

  // 문제 은행
  testbank: {},
  testbankList: {},
  testbankListFilter: {
    page: 0,
    size: 10,
    searchText: '',
    inThisRoom: true,
    roomId: ''
  },
  testbankExam: {},
  testbankExamList: {},
  testbankExamListFilter: {
    page: 0,
    size: 10,
    searchText: '',
  },

  // 출제 이력
  testbankExamHistory: {},
  testbankExamHistoryList: {},
  testbankExamHistoryListFilter: {
    page: 0,
    size: 10,
    examType: '',
    examTitle: '',
    inThisRoom: true,
  },
  testbankExamHistoryUser: {},
}
